export default [{
    path: '/finance',
    name: 'finance',
    component: () => import('@/views/modules/Finance/index.vue'),
    meta: {
      breadcrumb: [{
        text: 'finance.title',
        active: true,
      }],
      unique_name: "finance"
    },
  },
  {
    path: '/finance/charts',
    name: 'charts',
    component: () => import('@/views/modules/Finance/indicators/index.vue'),
    meta: {
      breadcrumb: [{
        text: 'finance.charts',
        i18n: 'finance.charts',
        active: true,
      }],
      unique_name: "finance-charts"
    },
  },

]